import { BooleanInput, Labeled, NumberInput, SelectInput, SimpleForm, TextInput, required } from "react-admin";

// поля реквизитов оплаты — те же, что в глобальных настройках; пустые добираются из глобальных
const REQUISITE_FIELDS: { key: string; label: string; multiline?: boolean }[] = [
  { key: "beneficiary_bank", label: "Банк получателя" },
  { key: "corr_account", label: "Корр. счёт банка" },
  { key: "bik", label: "БИК" },
  { key: "recipient_name", label: "Получатель" },
  { key: "recipient_inn", label: "ИНН получателя" },
  { key: "recipient_kpp", label: "КПП получателя" },
  { key: "settlement_account", label: "Расчётный счёт получателя" },
  { key: "purpose_template", label: "Назначение платежа ({cid}, {contract_date}, {reference})", multiline: true },
];

export const RATE_SOURCES = [
  { id: "profinance", name: "Profinance (USD/RUB)" },
  { id: "rapira", name: "Rapira (USDT/RUB)" },
];

export const KYC_MODES = [
  { id: "internal", name: "Наша проверка (ИИ)" },
  { id: "sumsub", name: "Sumsub" },
];

export function PromoForm() {
  return (
    <SimpleForm>
      <TextInput source="code" label="Код" validate={required()} helperText="Вводится в боте; без учёта регистра" />
      <NumberInput source="markup_pct" label="Наценка, %" validate={required()} helperText="Вместо дефолтных 2%" />
      <NumberInput source="min_rub" label="Мин. пополнение, ₽" validate={required()} />
      <NumberInput source="max_rub" label="Макс. пополнение, ₽" helperText="Пусто — глобальный максимум" />
      <SelectInput
        source="rate_source"
        label="Источник курса"
        choices={RATE_SOURCES}
        defaultValue="profinance"
        validate={required()}
        helperText="Биржевой курс, к которому применяется наценка"
      />
      <SelectInput
        source="kyc_mode"
        label="KYC-проверка"
        choices={KYC_MODES}
        defaultValue="internal"
        validate={required()}
        helperText="Наша проверка (ИИ) или внешний Sumsub"
      />
      <BooleanInput source="show_cards" label="Кнопка «Карты»" defaultValue={true} helperText="Показывать на главном экране" />
      <BooleanInput source="show_referrals" label="Кнопка «Партнёрам»" defaultValue={true} helperText="Показывать на главном экране" />
      <BooleanInput source="show_support" label="Кнопка «Техподдержка»" defaultValue={true} helperText="Показывать на главном экране" />
      <BooleanInput source="active" label="Активен" defaultValue={true} />
      <TextInput source="note" label="Заметка" multiline fullWidth />

      <Labeled label="Реквизиты оплаты (пусто — глобальные)" fullWidth>
        <>
          {REQUISITE_FIELDS.map((f) => (
            <TextInput
              key={f.key}
              source={`payment_requisites.${f.key}`}
              label={f.label}
              multiline={f.multiline}
              fullWidth
              helperText={false}
            />
          ))}
        </>
      </Labeled>
    </SimpleForm>
  );
}
